module.exports = __webpack_public_path__ + "img/IMG_2556-2.34480910.jpg";